import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSessionStorage } from "../../Hooks/useSessionStorage";
import { success } from "../../utils/AppUtils";
import { SESSION_STORAGE_VERSION_KEY } from "../../config/app.config";

export default function useVersionSyncNotification() {
    const { setStorageValue, value } = useSessionStorage<number>(SESSION_STORAGE_VERSION_KEY, 0);

    useEffect(() => {
        if (value === 1) {
            const timer = setTimeout(() => {
                setStorageValue(0);
                success(
                    <FormattedMessage id="notification.message.loaded-new-version" defaultMessage="Congratulations, now you are using the latest version." />,
                );
            }, 2500);

            return () => {
                clearTimeout(timer);
            };
        }
        return undefined;
    }, [value, setStorageValue]);
}
